// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../packages/core/lib/GlobalStateContext.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(sidebarOpt) {
  const sidebar = sidebarOpt !== undefined ? Caml_option.valFromOption(sidebarOpt) : null;
  return function (children) {
    const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
    const deviceType = state.deviceType;
    return JsxRuntime.jsxs("div", {
                children: [
                  sidebar,
                  children
                ],
                className: Cn.$plus("flex w-full h-100vh", Cn.on("flex-col", deviceType === "mobile"))
              });
  };
}

function DashboardTemplate(Props) {
  return make(Props.sidebar)(Props.children);
}

const make$1 = DashboardTemplate;

export {
  make$1 as make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
